import { render, staticRenderFns } from "./FormsPanel.vue?vue&type=template&id=4bfe0d9b&scoped=true"
import script from "./FormsPanel.vue?vue&type=script&lang=js"
export * from "./FormsPanel.vue?vue&type=script&lang=js"
import style0 from "./FormsPanel.vue?vue&type=style&index=0&id=4bfe0d9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe0d9b",
  null
  
)

export default component.exports